import { PERFILES } from '@src/perfiles'

const redirectToModuleByPerfil = (perfil) => {
  switch (perfil) {
    case PERFILES.Armeria:
      window.location.replace('armeria/inventario_armas')
      break
    case PERFILES.Equipamiento:
      window.location.replace('equipamiento/personal')
      break
    case PERFILES.Profesionalización:
      window.location.replace('profesionalizacion/dashboard')
      break
    case PERFILES['Personal / Site']:
      window.location.replace('personal/dashboard')
      break
    case PERFILES['Recursos Humanos']:
      window.location.replace('recursos_humanos/dashboard')
      break
    case PERFILES['Enlace C3']:
      window.location.replace('enlace_c3/dashboard')
      break
    case PERFILES['Administrador IPH+']:
      window.location.replace('launcher')
      break
    case PERFILES['Asuntos Internos']:
      window.location.replace('asuntos_internos/personal')
      break
    case PERFILES['Consejo de Honor y Justicia']:
      window.location.replace('asuntos_internos/personal')
      break
    case PERFILES.Policia:
      window.location.replace('policia/' + this.idPersonal)
      break

    // * Nuevos perfiles
    case PERFILES.IFCSP_PROFESIONALIZACION:
      window.location.replace('profesionalizacion/dashboard')
      break
    case PERFILES.IFCSP_RECLUTAMIENTO:
      window.location.replace('profesionalizacion/dashboard')
      break
    case PERFILES.IFCSP_ADMINISTRADOR:
      window.location.replace('profesionalizacion/dashboard')
      break
    case PERFILES.REP_ADMINISTRADOR:
      window.location.replace('personal/dashboard')
      break
    case PERFILES.REP_REGISTRO:
      window.location.replace('personal/dashboard')
      break
    case PERFILES.REP_CREDENCIALIZACION:
      window.location.replace('personal/dashboard')
      break
    case PERFILES.REP_BIOMETRIA:
      window.location.replace('personal/dashboard')
      break
    case PERFILES['ENLACE_C3_CAPTURA_RESULTADOS']:
      window.location.replace('enlace_c3/dashboard')
      break
    case PERFILES['ENLACE_C3_CAPTURA_EXPEDIENTE']:
      window.location.replace('enlace_c3/dashboard')
      break
    case PERFILES['ENLACE_C3_ADMINISTRADOR']:
      window.location.replace('enlace_c3/dashboard')
      break
    case PERFILES.RH_ADMINISTRADOR:
      window.location.replace('recursos_humanos/dashboard')
      break
    case PERFILES['RH_TRAMITES ADMINISTRATIVOS']:
      window.location.replace('recursos_humanos/dashboard')
      break
    case PERFILES['RH_CAMBIO DE ESTATUS/ADSCRIPCION']:
      window.location.replace('recursos_humanos/dashboard')
      break
    case PERFILES['RH_REGISTRO DE PERSONAL']:
      window.location.replace('recursos_humanos/dashboard')
      break
    case PERFILES['ARMERIA_PASE DE LISTA']:
      window.location.replace('armeria/inventario_armas')
      break
    case PERFILES.ARMERIA_LOC:
      window.location.replace('armeria/inventario_armas')
      break
    case PERFILES['ARMERIA_PERSONAL LOC']:
      window.location.replace('armeria/inventario_armas')
      break
    case PERFILES['ARMERIA_CATALOGOS E INVENTARIO ARMAS']:
      window.location.replace('armeria/inventario_armas')
      break
    case PERFILES['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS']:
      window.location.replace('armeria/inventario_armas')
      break
    case PERFILES.EQUIPAMIENTO_ADMINISTRADOR:
      window.location.replace('equipamiento/personal')
      break
    case PERFILES.DP_ADMINISTRADOR:
      window.location.replace('desarrollo_profesional/personal')
      break
    case PERFILES.DP_EVALUACIONES:
      window.location.replace('desarrollo_profesional/personal')
      break
    case PERFILES.DP_CONVOCATORIAS_CONDECORACIONES:
      window.location.replace('desarrollo_profesional/personal')
      break
    case PERFILES.COMISARIA_CAPTURA:
      window.location.replace('enlace/pase_lista')
      break
    case PERFILES.COMISARIA_SUPERVISOR:
      window.location.replace('enlace/pase_lista')
      break
    default:
      console.log('Perfil no reconocido:', perfil)
      break
  }
}

export default redirectToModuleByPerfil
